import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { AppRouter } from './components/AppRouter/AppRouter';
import { BrowserDetector } from './components/BrowserDetector/BrowserDetector';
import { ConfigurationLoader } from './components/ConfigurationLoader/ConfigurationLoader';
import { FileViewer } from './components/DataDisplay/File/FileViewer';
import { ErrorBoundary } from './components/Layout/ErrorBoundary';
import { renderResponsiveAppErrorFallback } from './components/Layout/ResponsiveAppErrorFallback';
import { ROUTE } from './constants/routes';
import { useAppDispatch, useAppSelector } from './hooks/redux';
import { useLayoutBranchDesktop } from './hooks/useResponsive';
import { AuthenticatedPage } from './pages/desktop/root/AuthenticatedPage';
import { UnauthenticatedPage } from './pages/desktop/root/UnauthenticatedPage';
import { AuthenticatedScreen } from './pages/mobile/root/AuthenticatedScreen';
import OpenRepublicSuperAppPage from './pages/open-republic-super-app';
import { setTenant } from './redux/configs';
import {
  hideFileViewer,
  selectUIState,
  setFileViewerScrolledToBottom,
} from './redux/ui';
import { Tenant } from './types/common';
import { isCaymanDomain } from './utils/domain';

export function ResponsiveApp() {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const layoutIsDesktop = useLayoutBranchDesktop();
  const { fileViewer } = useAppSelector(selectUIState);

  const onCloseFileViewer = () => {
    dispatch(hideFileViewer());
  };

  const onFileViewerScrolledToBottom = () => {
    dispatch(setFileViewerScrolledToBottom(true));
  };

  useEffect(() => {
    if (isCaymanDomain) {
      dispatch(
        setTenant({
          tenant: Tenant.Cayman,
        }),
      );
    }
  }, [dispatch]);

  if (pathname === ROUTE.OPEN_REPUBLIC_SUPER_APP) {
    return <OpenRepublicSuperAppPage />;
  }

  return (
    <ErrorBoundary fallback={renderResponsiveAppErrorFallback}>
      <BrowserDetector fullScreen={!layoutIsDesktop}>
        <ConfigurationLoader>
          <AppRouter
            protectedPage={
              layoutIsDesktop ? <AuthenticatedPage /> : <AuthenticatedScreen />
            }
            publicPage={<UnauthenticatedPage />}
          />
        </ConfigurationLoader>
      </BrowserDetector>
      {fileViewer && (
        <FileViewer
          src={fileViewer.src}
          type={fileViewer.type}
          onClose={onCloseFileViewer}
          onPDFScrolledToBottom={onFileViewerScrolledToBottom}
        />
      )}
    </ErrorBoundary>
  );
}
